<quill-editor
  class="quill-editor h-full"
  [classes]="internalClasses"
  [class.mentions-editor]="applyMention()"
  [class.toolbar-hidden]="!applyToolbar()"
  [class.readonly]="readOnly()"
  [class.no-border]="!applyBorder()"
  [id]="inputId()"
  [theme]="applyTheme() ? 'snow' : null"
  [placeholder]="placeholder()"
  [styles]="styles"
  [modules]="{ toolbar: modulesToolbar, mention: applyMention() ? modulesMention : false }"
  [readOnly]="readOnly()"
  [formControl]="control"
  (onEditorCreated)="onEditorCreated($event)"
  (onContentChanged)="onContentChangedListen($event)"
  (ngModelChange)="onChange(filterValue($event))"
/>
@if (!readOnly() && showValidationMessage()) {
  <svc-validation-message [control]="control"/>
}
